export type ColumnKey =
  | 'name'
  | 'contractCode'
  | 'displayOrder'
  | 'maxHoursPerWeek'
  | 'maxHoursPerDay'
  | 'maxHoursPerShift'
  | 'earliestStartTime'
  | 'latestEndTime';

export interface ColumnDefinition {
  key: ColumnKey;
  defaultVisible: boolean;
  align: 'left' | 'center';
}

export const COLUMN_DEFINITIONS: ColumnDefinition[] = [
  {
    key: 'name',
    defaultVisible: true,
    align: 'left'
  },
  {
    key: 'contractCode',
    defaultVisible: false,
    align: 'left'
  },
  {
    key: 'displayOrder',
    defaultVisible: false,
    align: 'center'
  },
  {
    key: 'maxHoursPerWeek',
    defaultVisible: true,
    align: 'center'
  },
  {
    key: 'maxHoursPerDay',
    defaultVisible: false,
    align: 'center'
  },
  {
    key: 'maxHoursPerShift',
    defaultVisible: false,
    align: 'center'
  },
  {
    key: 'earliestStartTime',
    defaultVisible: false,
    align: 'center'
  },
  {
    key: 'latestEndTime',
    defaultVisible: false,
    align: 'center'
  }
];

export const VALID_KEYS = new Set<ColumnKey>(COLUMN_DEFINITIONS.map(c => c.key));
export const DEFAULT_VISIBLE: ColumnKey[] = COLUMN_DEFINITIONS.filter(c => c.defaultVisible).map(c => c.key);
export const COLUMNS_STORAGE_KEY = 'admin_contract_table_columns_v1';
